// extracted by mini-css-extract-plugin
export var customTable = "styles-module--custom-table--4e462";
export var customTableContainer = "styles-module--custom-table-container--ad64c";
export var hasOverflow = "styles-module--has-overflow--d08c0";
export var largeTable = "styles-module--large-table--fe568";